<template>
  <address>
    <span v-if="storeAddress.name">
      {{ storeAddress.name }},<br />
    </span>
    <span v-if="storeAddress.address1">
      {{ storeAddress.address1 }},<br />
    </span>
    <span v-if="storeAddress.address2">
      {{ storeAddress.address2 }},<br />
    </span>
    <span v-if="storeAddress.address3">
      {{ storeAddress.address3 }},<br />
    </span>
    <span v-if="storeAddress.address4">
      {{ storeAddress.address4 }},<br />
    </span>
    {{ storeAddress.postcode }}<br />
  </address>
</template>

<script>
export default {
  name: 'StoreAddress',
  props: ['storeAddress']
}
</script>
